import Vue from 'vue'
import Router from 'vue-router'
// import Dashboard from '@/components/Dashboard'
import UserProfile from '@/components/UserProfile'
import Relation from '@/components/Relation'
import RelationAdd from '@/components/Relation/RelationAdd'
import Chat from '@/components/Chat'
// import TableList from '@/components/TableList'
// import Typography from '@/components/Typography'
// import Icons from '@/components/Icons'
// import Maps from '@/components/Maps'
import Notifications from '@/components/Notifications'
import Login from '@/components/Account/Login'
import RegisterStudent from '@/components/Account/RegisterStudent'
import RegisterTeacher from '@/components/Account/RegisterTeacher'
import Subjects from '@/components/Subject'
import Lessons from '@/components/Lesson'
import Videos from '@/components/Videos'
// import VideoAdd from '@/components/Videos/add'
import VideoAddCustom from '@/components/Videos/add_custom'
import VideoEdit from '@/components/Videos/edit'
import Category from '@/components/Category'
// import LessonAdd from '@/components/Lesson/add'
import LessonAddCustom from '@/components/Lesson/add_custom'
import LessonEdit from '@/components/Lesson/edit'
import LessonView from '@/components/Lesson/view'
import Achievement from '@/components/Achievement'
import Grade from '@/components/Grade'
import Beepoint from '@/components/Point/Beepoint'
import Diamond from '@/components/Point/Diamond'
import HoneyJars from '@/components/Point/HoneyJars'
import PC from '@/components/PC'
import PCStep from '@/components/PC/step'
import PCEdit from '@/components/PC/edit'
import Member from '@/components/Member'
import MemberAdd from '@/components/Member/add'
import MemberEdit from '@/components/Member/edit'
import MemberApproval from '@/components/Member/approval'
import Classes from '@/components/Classes'
import ClassesAdd from '@/components/Classes/add'
import ClassesEdit from '@/components/Classes/edit'
import S3FileUpload from '@/components/S3FileUpload'
import TermsOfUse from '@/components/Front/Page/terms_of_use'
import Policy from '@/components/Front/Page/policy'
import Body from '@/components/Front/Body'
import PageLesson from '@/components/Front/Page/Lesson/infinite'
import PageLessonDetail from '@/components/Front/Page/Lesson/detail'
import PageVideo from '@/components/Front/Page/Video/infinite'
import PageVideoDetail from '@/components/Front/Page/Video/detail'
import PagePublic from '@/components/Front/Page/Public/infinite'
import PagePublicDetail from '@/components/Front/Page/Public/detail'
import JoinClasses from '@/components/Front/Page/ClassesMe/join.vue'
import LandingPage from '@/components/Front/LandingPage'
import LandingLesson from '@/components/Front/LandingPage/Lesson/infinite'
import LandingLessonDetail from '@/components/Front/LandingPage/Lesson/detail'
import LandingVideo from '@/components/Front/LandingPage/Video/infinite'
import LandingVideoDetail from '@/components/Front/LandingPage/Video/detail'
import LandingExercise from '@/components/Front/LandingPage/Exercise/infinite'
import LandingExerciseDetail from '@/components/Front/LandingPage/Exercise/detail'
import CategoryQuestion from '@/components/Question/Category'
import CategoryExercise from '@/components/Exercise/Category'
import Question from '@/components/Question'
import QuestionAdd from '@/components/Question/add'
import QuestionEdit from '@/components/Question/edit'
import Exercise from '@/components/Exercise'
import ExerciseAdd from '@/components/Exercise/add'
import ExerciseEdit from '@/components/Exercise/edit'
import Result from '@/components/Exercise/Result'
import ClassesMe from '@/components/ClassesMe'
import ClassesMeDetail from '@/components/ClassesMe/detail.vue'
import Channel from '@/components/Channel'
import LessonPlanning from '@/components/Lesson_Planning'
import LessonPlanningLesson from '@/components/Lesson_Planning/Lesson'
import LessonPlanningLessonAdd from '@/components/Lesson_Planning/Lesson/add'
import LessonPlanningVideo from '@/components/Lesson_Planning/Video'
import LessonPlanningVideoAdd from '@/components/Lesson_Planning/Video/add'
import LessonPlanningExercise from '@/components/Lesson_Planning/Exercise'
import LessonPlanningExerciseAdd from '@/components/Lesson_Planning/Exercise/add'
// Admin
// import AdminQuestion from '@/components/Question/admin_index'
// import AdminQuestionAdd from '@/components/Question/admin_add'
// import AdminQuestionEdit from '@/components/Question/admin_edit'

// GeneralViews
// import NotFound from '@/components/GeneralViews/NotFound.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'Dashboard',
    //   component: Dashboard
    // },
    {
      path: '/account',
      name: 'Account',
      component: UserProfile,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/account/profile',
          name: 'Profile',
          component: UserProfile
        }
      ]
    },
    {
      path: '/account-view',
      name: 'account-view',
      component: UserProfile,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/register',
    //   name: 'Register',
    //   children: [
    //     {
    //       path: '/register/register-student',
    //       name: 'Register Student',
    //       component: RegisterStudent
    //     },
    //     {
    //       path: '/register/register-teacher',
    //       name: 'Register Teacher',
    //       component: RegisterTeacher
    //     }
    //   ]
    // },
    {
      path: '/relation',
      name: 'relation',
      component: Relation,
      props: {},
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relation-add',
      name: 'relation-add',
      component: RelationAdd,
      props: {},
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/register-student',
      name: 'Register Student',
      component: RegisterStudent,
      props: {},
      meta: {
        loggedIn: true
      }
    },
    {
      path: '/register-teacher',
      name: 'Register Teacher',
      component: RegisterTeacher,
      meta: {
        loggedIn: true
      }
    },
    {
      path: '/chat',
      name: 'chat',
      component: Chat,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/table',
    //   name: 'TableList',
    //   component: TableList
    // },
    // {
    //   path: '/typography',
    //   name: 'Typography',
    //   component: Typography
    // },
    // {
    //   path: '/icons',
    //   name: 'Icons',
    //   component: Icons
    // },
    // {
    //   path: '/maps',
    //   name: 'Maps',
    //   component: Maps
    // },
    {
      path: '/category',
      name: 'Category',
      component: Category,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/lessons',
      name: 'Lesson',
      component: Lessons,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/lesson_add',
      name: 'lesson_add',
      component: LessonAddCustom,
      meta: {
        parentName: 'Lesson',
        requiresAuth: true,
        isTeacher: true
      }
    },
    // {
    //   path: '/lesson_add_custom',
    //   name: 'lesson_add_custom',
    //   component: LessonAdd,
    //   meta: {
    //     requiresAuth: true,
    //     isTeacher: true
    //   }
    // },
    {
      path: '/lesson_edit/:lesson_id',
      name: 'lesson_edit',
      component: LessonEdit,
      meta: {
        parentName: 'Lesson',
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/lesson_view/:lesson_id',
      name: 'lesson_view',
      component: LessonView,
      meta: {
        parentName: 'Lesson',
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/videos',
      name: 'Videos',
      component: Videos,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/video_add',
      name: 'video_add',
      component: VideoAddCustom,
      meta: {
        parentName: 'Videos',
        requiresAuth: true,
        isTeacher: true
      }
    },
    // {
    //   path: '/video_add_custom',
    //   name: 'video_add_custom',
    //   component: VideoAdd,
    //   meta: {
    //     requiresAuth: true,
    //     isTeacher: true
    //   }
    // },
    {
      path: '/video_edit/:lesson_id',
      name: 'video_edit',
      component: VideoEdit,
      meta: {
        parentName: 'Videos',
        requiresAuth: true,
        isTeacher: true
      }
    },
    // ngan hang bai tap
    {
      path: '/exercise',
      name: 'exercise',
      component: Exercise,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/exercise_add',
      name: 'exercise_add',
      component: ExerciseAdd,
      meta: {
        parentName: 'exercise',
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/exercise_edit/:id',
      name: 'exercise_edit',
      component: ExerciseEdit,
      meta: {
        parentName: 'exercise',
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/category-exercise',
      name: 'category-exercise',
      component: CategoryExercise,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/question',
      name: 'question',
      component: Question,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/question_add',
      name: 'question_add',
      component: QuestionAdd,
      meta: {
        parentName: 'question',
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/question_edit/:id',
      name: 'question_edit',
      component: QuestionEdit,
      meta: {
        parentName: 'question',
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/category-question',
      name: 'category-question',
      component: CategoryQuestion,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/achievement',
      name: 'Achievement',
      component: Achievement,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/grades',
      name: 'Grade',
      component: Grade,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/subjects',
      name: 'Subjects',
      component: Subjects,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/beepoint',
      name: 'beepoint',
      component: Beepoint,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/diamond',
      name: 'diamond',
      component: Diamond,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/honeyjars',
      name: 'honeyjars',
      component: HoneyJars,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/notifications',
      name: 'Notifications',
      component: Notifications,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/general',
      name: 'general',
      component: PC,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/general_step',
      name: 'general_step',
      component: PCStep,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/general_edit',
      name: 'general_edit',
      component: PCEdit,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/classes',
      name: 'classes',
      component: Classes,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/classes_add',
      name: 'classes_add',
      component: ClassesAdd,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/classes_edit',
      name: 'classes_edit',
      component: ClassesEdit,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/channel',
      name: 'channel',
      component: Channel,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/member',
      name: 'member',
      component: Member,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/member-add',
      name: 'member_add',
      component: MemberAdd,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/member-edit',
      name: 'member_edit',
      component: MemberEdit,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/member-approval',
      name: 'member_approval',
      component: MemberApproval,
      meta: {
        requiresAuth: true,
        isTeacher: true
      }
    },
    {
      path: '/classes-to-me',
      name: 'classes_to_me',
      component: ClassesMe,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/classes-to-me/detail',
      name: 'classes_to_me_detail',
      component: ClassesMeDetail,
      meta: {
        parentName: 'classes_to_me',
        requiresAuth: true
      }
    },
    {
      path: '/classes-to-me/:alias/chat',
      name: 'classes_to_me_chat',
      component: ClassesMeDetail,
      meta: {
        parentName: 'classes_to_me',
        requiresAuth: true
      }
    },
    {
      path: '/classes-to-me/:alias/lesson',
      name: 'classes_to_me_lesson',
      component: ClassesMeDetail,
      meta: {
        parentName: 'classes_to_me',
        requiresAuth: true
      }
    },
    {
      path: '/classes-to-me/:alias/video',
      name: 'classes_to_me_video',
      component: ClassesMeDetail,
      meta: {
        parentName: 'classes_to_me',
        requiresAuth: true
      }
    },
    {
      path: '/classes-to-me/:alias/exercise',
      name: 'classes_to_me_exercise',
      component: ClassesMeDetail,
      meta: {
        parentName: 'classes_to_me',
        requiresAuth: true
      }
    },
    {
      path: '/classes-to-me/:alias',
      name: 'classes_to_me_channel',
      component: ClassesMeDetail,
      meta: {
        parentName: 'classes_to_me',
        requiresAuth: true
      }
    },
    {
      path: '/result',
      name: 'result',
      component: Result,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/lesson-planning',
      name: 'lesson_planning',
      component: LessonPlanning,
      meta: {
        isTeacher: true,
        requiresAuth: true
      }
    },
    {
      path: '/lesson-planning/lesson',
      name: 'lesson_planning_lesson',
      component: LessonPlanningLesson,
      meta: {
        isTeacher: true,
        requiresAuth: true
      }
    },
    {
      path: '/lesson-planning/lesson_add',
      name: 'lesson_planning_lesson_add',
      component: LessonPlanningLessonAdd,
      meta: {
        isTeacher: true,
        requiresAuth: true
      }
    },
    {
      path: '/lesson-planning/video',
      name: 'lesson_planning_video',
      component: LessonPlanningVideo,
      meta: {
        isTeacher: true,
        requiresAuth: true
      }
    },
    {
      path: '/lesson-planning/video_add',
      name: 'lesson_planning_video_add',
      component: LessonPlanningVideoAdd,
      meta: {
        isTeacher: true,
        requiresAuth: true
      }
    },
    {
      path: '/lesson-planning/exercise',
      name: 'lesson_planning_exercise',
      component: LessonPlanningExercise,
      meta: {
        isTeacher: true,
        requiresAuth: true
      }
    },
    {
      path: '/lesson-planning/exercise_add',
      name: 'lesson_planning_exercise_add',
      component: LessonPlanningExerciseAdd,
      meta: {
        isTeacher: true,
        requiresAuth: true
      }
    },
    {
      path: '/s3fileupload',
      name: 'S3FileUpload',
      component: S3FileUpload,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        loggedIn: true
      }
    },
    // ===================== ADMIN PAGE ======================= //
    // {
    //   path: '/admin-question',
    //   name: 'admin_question',
    //   component: AdminQuestion,
    //   meta: {
    //     requiresAuth: true,
    //     isAdmin: true
    //   }
    // },
    // {
    //   path: '/admin-question-add',
    //   name: 'admin_question_add',
    //   component: AdminQuestionAdd,
    //   meta: {
    //     parentName: 'admin_question',
    //     requiresAuth: true,
    //     isAdmin: true
    //   }
    // },
    // {
    //   path: '/admin-question-edit/:id',
    //   name: 'admin_question_edit',
    //   component: AdminQuestionEdit,
    //   meta: {
    //     parentName: 'admin_question',
    //     requiresAuth: true,
    //     isAdmin: true
    //   }
    // },
    // ======================================================== //
    {
      path: '/terms-of-use',
      name: 'terms_of_use',
      component: TermsOfUse
    },
    {
      path: '/policy',
      name: 'policy',
      component: Policy
    },
    {
      path: '/home',
      name: 'body',
      component: Body
    },
    {
      path: '/page-lesson',
      name: 'page_lesson',
      component: PageLesson
    },
    {
      path: '/page-lesson/detail/:id',
      name: 'page_lesson_detail',
      component: PageLessonDetail
    },
    {
      path: '/page-video',
      name: 'page_video',
      component: PageVideo
    },
    {
      path: '/page-video/detail/:id',
      name: 'page_video_detail',
      component: PageVideoDetail
    },
    {
      path: '/page-public',
      name: 'page_public',
      component: PagePublic
    },
    {
      path: '/pc-*',
      name: 'page_public_detail',
      component: PagePublicDetail
    },
    {
      path: '/classes-join',
      name: 'page_classes_join',
      component: JoinClasses
    },
    {
      path: '/landing/*-:id',
      name: 'landing',
      component: LandingPage
    },
    {
      path: '/join-classes/*:alias-:id/yeucauthamgia',
      name: 'join_classes',
      component: JoinClasses
    },
    {
      path: '/landing/*-:id/lesson',
      name: 'landing_lesson',
      component: LandingLesson,
      meta: {
        parentName: 'landing'
      }
    },
    {
      path: '/landing/*-:id/lesson/:gradeID',
      name: 'landing_lesson_grade',
      component: LandingLesson,
      meta: {
        parentName: 'landing'
      }
    },
    {
      path: '/landing/*-:id/lesson/detail/:idDetail',
      name: 'landing_lesson_detail',
      component: LandingLessonDetail,
      meta: {
        parentName: 'landing'
      }
    },
    {
      path: '/landing/*-:id/video',
      name: 'landing_video',
      component: LandingVideo,
      meta: {
        parentName: 'landing'
      }
    },
    {
      path: '/landing/*-:id/video/:gradeID',
      name: 'landing_video_grade',
      component: LandingVideo,
      meta: {
        parentName: 'landing'
      }
    },
    {
      path: '/landing/*-:id/video/detail/:idDetail',
      name: 'landing_video_detail',
      component: LandingVideoDetail,
      meta: {
        parentName: 'landing'
      }
    },
    {
      path: '/landing/*-:id/exercise',
      name: 'landing_exercise',
      component: LandingExercise,
      meta: {
        parentName: 'landing'
      }
    },
    {
      path: '/landing/*-:id/exercise/:gradeID',
      name: 'landing_exercise',
      component: LandingExercise,
      meta: {
        parentName: 'landing'
      }
    },
    {
      path: '/landing/*-:id/exercise/detail/:idDetail',
      name: 'landing_exercise_detail',
      component: LandingExerciseDetail,
      meta: {
        parentName: 'landing'
      }
    },
    {
      path: '/landing/*-:id/exercise/detail/:idDetail/result',
      name: 'landing_exercise_detail_result',
      component: LandingExerciseDetail,
      meta: {
        parentName: 'landing'
      }
    },
    // {
    //   path: '*',
    //   // redirect: '/login'
    //   component: NotFound
    // }
    {
      path: '/',
      redirect: '/home'
    }
  ],
  linkActiveClass: 'active'
})



// WEBPACK FOOTER //
// ./src/router/index.js